__turbopack_context__.v({
  "icon": "styles-module__-BCpEa__icon",
});
